import { inject, Pipe, PipeTransform } from '@angular/core';

import { LaunchdarklyService } from '../services';

@Pipe({
  name: 'avsFeatureFlag',
  pure: false,
  standalone: true,
})
export class FeatureFlagPipe implements PipeTransform {
  private ldService = inject(LaunchdarklyService);

  isFlagEnabled(flag: string) {
    return this.ldService.isFlagEnabled(flag, false);
  }

  transform(flag: string) {
    return this.isFlagEnabled(flag);
  }
}
